<template>
  <div>
    <ly-crud ref="lycrud" v-bind="crudConfig">
      <template v-slot:customHandle="slotProps">
        <span class="table-operate-btn" @click="handleClick(slotProps.row, 'disable')"
          v-show="hasPermission('deviceCrud', 'Disable')">禁用</span>
      </template>

    </ly-crud>

  </div>
</template>

<script lang="jsx">
var eq_type_list = [];

import {
  authorization_codeList,
  authorization_codeEdit,
  authorization_codeAdd,
  authorization_codeDelete,
  authorization_code_eq_typeList,
} from "@/api/api";
import LyCrud from "@/components/lycrud_auth";
import templateData from "@/components/dict/crudTemplateData";
import { h, resolveComponent } from "vue";
export default {
  name: "deviceCrud",
  components: { LyCrud },
  data() {
    return {

      show_down: false,
      defaultImg: require("../../assets/img/avatar.jpg"),
      //crud配置
      crudConfig: {
        eq_type_list:eq_type_list,
        //crud请求方法配置
        crudRequest: {
          add: authorization_codeAdd,
          del: authorization_codeDelete,
          edit: authorization_codeEdit,
          search: authorization_codeList,
        },
        //搜索栏目配置
        searchBar: {
          showSearchBar: true, //显示搜索栏目
          searchColums: [
            {
              label: "授权码",
              type: "input",
              prop: "search",
              width: 200,
              maxlength: 60,
              placeholder: "授权码",
            },
            // { label: '手机号', type: 'input', prop: 'mobile', width: 200, maxlength: 60, placeholder: '请输入手机号' },
            // {
            //     label: '状态', type: 'select', prop: 'is_active', width: 100, placeholder: '请选择',
            //     options: [
            //         { value: 1, label: '正常' },
            //         { value: 0, label: '禁用' }
            //     ]
            // },
            // { label: '创建时间', type: 'datepicker-datetimerange', prop: 'timers' },
          ],
        },
        //显示分页
        showPagination: true,
        //分页配置
        pageparams: {
          limit: 10, //每页显示的条数(默认每页显示10条)//非必填
          //pageSizes:[10,20,30,40,50,200],//非必填
          // layout:'total, sizes, prev, pager, next, jumper',//非必填
        },
        //crud按钮配置
        rowHandle: {
          width: 180, //操作列宽度
          fixed: "right", //固定操作列在右侧
          permission: {
            //增删改查按钮权限控制（是否显示）
            add: this.hasPermission("authorization_codeManage", "Create"), //bool型
            del: this.hasPermission("authorization_codeManage", "Delete"),
            edit: this.hasPermission("authorization_codeManage", "Update"),
            search: this.hasPermission("authorization_codeManage", "Search"),
            detail: this.hasPermission("authorization_codeManage", "Retrieve"),
          },
        },
        //crud弹窗属性
        formOptions: {
          width: "45%", //dialog弹窗宽度：类型：百分比或字符串
          gutter: 20, // Layout布局栅格间隔
        },
        //crud表格属性
        tableOptions: {
          border: true,
          showHeader: true,
        },
        showSelectable: true, //表格显示复选项框
        showSequence:false,
        //table表头列
        tableColumns: [
          // {label:'用户头像',type:'image',prop:'avatar',minWidth:'60',sortable: false,hidden:false,render:(row)=>{
          //     let elImage = resolveComponent('el-image')//全局组件需要先resolveComponent解析该组件再render渲染，不然该标签会出现原样输出
          //     return h(elImage,{
          //          src:row.avatar ? row.avatar : this.defaultImg,
          //          previewSrcList:[row.avatar ? row.avatar : this.defaultImg],//开启预览，原preview-src-list属性在h渲染方法中，-后字母大写代替即可：previewSrcList
          //          previewTeleported:true,//插入至body元素上
          //          style:"width: 30px;height: 30px",
          //     },)
          //  }
          // },
          {
            label: "ID",
            prop: "id",
            type: "input",
            minWidth: "100",
            sortable: false,
            hidden: true,
            form: {
              //表单属性
              span: 24,
              hidden: true, //编辑时隐藏，添加时去除
            },
          },
          {
            label: "授权码",
            type: "input",
            prop: "authorization_code",
            minWidth: "60",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "",
              editDisabled: true,
            },
          },
          
          {
            label: "有效期",
            prop: "validity",
            type: "datetime",
            minWidth: "100",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "date",
            },
          },
          {
            label: "客户公司",
            prop: "company",
            type: "input",
            minWidth: "110",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "",
            },
          },
          // {
          //   label: "性质",
          //   prop: "authorization_code_nature",
          //   type: "input",
          //   minWidth: "110",
          //   sortable: false,
          //   hidden: false,
          //   form: {
          //     //表单属性
          //     span: 12,
          //     placeholder: "",
          //   },
          // },
          {
            label: "性质",
            prop: "authorization_code_nature",
            type: "select",
            minWidth: "100",
            sortable: false,
            hidden: false,

            form: {
              // 表单属性
              span: 12,
              options: [
                { label: "定制", value: "定制" },
                { label: "中性", value: "中性" },
              ],
              defaultValue: '定制', // 新增时的默认值，改为 1 表示启用
              // valueChange(e) { // 值变化回调事件
              //     console.log(e, '---变化的值');
              // },
            },
          },
          {
            label: "小程序码",
            prop: "wxacodeunlimit",
            type: "image-avatar",
            minWidth: "60",
            sortable: false,
            hidden: false,
            render: (row) => {
              return (
                <el-image
                  src={
                    row.wxacodeunlimit
                      ? this.updateURL(row.wxacodeunlimit, row.authorization_code)
                      : this.defaultImg
                  }
                  style="width: 60px;height: 60px "
                  preview-teleported={true}
                  preview-srcList={[
                    row.wxacodeunlimit
                      ? this.updateURL(row.wxacodeunlimit, row.authorization_code)
                      : this.defaultImg,
                  ]}
                >

                </el-image>
              );
            },
          },
          {
            label: "信息采集",
            prop: "userinfo",
            type: "select",
            minWidth: "100",
            sortable: false,
            hidden: false,
            render: (row) => {
              let foundElement = [
                { label: "采集用户信息", value: 1 },
                { label: "不采集用户信息", value: 2 },
              ].find((element) => element.value == row.userinfo);
              return foundElement ? foundElement.label : "";
            },
            form: {
              // 表单属性
              span: 12,
              options: [
                { label: "采集用户信息", value: 1 },
                { label: "不采集用户信息", value: 2 },
              ],
              defaultValue: 1, // 新增时的默认值，改为 1 表示启用
              // valueChange(e) { // 值变化回调事件
              //     console.log(e, '---变化的值');
              // },
            },
          },
          {
            label: "发件人邮箱",
            prop: "email_host_user",
            type: "input",
            minWidth: "110",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "",
              defaultValue: 'mini@chinasimba.com'
            },
          },
          {
            label: "端口",
            type: "input",
            prop: "email_port",
            minWidth: "60",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "",
              editDisabled: false,
            },
          },
          {
            label: "端口类型",
            prop: "email_port_type",
            type: "select",
            minWidth: "100",
            sortable: false,
            hidden: false,
            render: (row) => {
              let foundElement = [
                { label: "smtp端口", value: 1 },
                { label: "exchange端口", value: 2 },
              ].find((element) => element.value == row.email_port_type);
              return foundElement ? foundElement.label : "";
            },
            form: {
              // 表单属性
              span: 12,
              options: [
                { label: "smtp端口", value: 1 },
                { label: "exchange端口", value: 2 },
              ],
              defaultValue: 1, // 新增时的默认值，改为 1 表示启用
              // valueChange(e) { // 值变化回调事件
              //     console.log(e, '---变化的值');
              // },
            },
          },
          
          
          {
            label: "服务端邮箱",
            prop: "email_host",
            type: "input",
            minWidth: "110",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "",
              defaultValue: 'smtp.chinasimba.com'
            },
          },
          {
            label: "邮箱授权码",
            prop: "email_host_password",
            type: "password",
            minWidth: "100",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "",
              defaultValue: 'HRVgvohg26xhXsoj'

            },
          },
          {
            label: '高级菜单',
            prop: 'advanced_menu',
            type: 'radio',
            minWidth: '100',
            sortable: false,
            hidden: false,
            render: (row) => {
              let elTag = resolveComponent('el-tag'); // 解析全局组件
              if (row.advanced_menu === 0) {
                return h(elTag, {
                  type: 'warning'
                }, () => '禁用'); // 返回 "禁用"
              } else {
                return h(elTag, {
                  type: 'success'
                }, () => '启用'); // 返回 "正常"
              }
            },
            form: {
              // 表单属性
              span: 12,
              options: [
                { label: '启用', value: 1 },
                { label: '禁用', value: 0 }
              ],
              defaultValue: 0, // 新增时的默认值，改为 1 表示启用
              // valueChange(e) { // 值变化回调事件
              //     console.log(e, '---变化的值');
              // },
            }
          },
          
          {
            label: "高级菜单密码",
            type: "password",
            prop: "license_pwd",
            minWidth: "60",
            sortable: false,
            hidden: false,
            form: {
              //表单属性
              span: 12,
              placeholder: "",
              editDisabled: false,
            },
          },
          {
            label: "展示图片1",
            prop: "picurl1",
            type: "image-avatar",
            minWidth: "60",
            sortable: false,
            hidden: true,
            render: (row) => {
              return (
                <el-image
                  src={row.picurl1 ? row.picurl1 : this.defaultImg}
                  style="width: 100px;height: 40px"
                  preview-teleported={true}
                  preview-srcList={[row.picurl1 ? row.picurl1 : this.defaultImg]}
                ></el-image>
              );
            },
            form: {
              //表单属性
              span: 12,
              width: 200,
              height: 80,
              hidden: false,
            },
          },
          {
            label: "展示图片2",
            prop: "picurl2",
            type: "image-avatar",
            minWidth: "60",
            sortable: false,
            hidden: true,
            render: (row) => {
              return (
                <el-image
                  src={row.picurl2 ? row.picurl2 : this.defaultImg}
                  style="width: 100px;height: 40px"
                  preview-teleported={true}
                  preview-srcList={[row.picurl2 ? row.picurl2 : this.defaultImg]}
                ></el-image>
              );
            },
            form: {
              //表单属性
              span: 12,
              width: 200,
              height: 80,
              hidden: false,
            },
          },
          {
            label: "展示图片3",
            prop: "picurl3",
            type: "image-avatar",
            minWidth: "60",
            sortable: false,
            hidden: true,
            render: (row) => {
              return (
                <el-image
                  src={row.picurl3 ? row.picurl3 : this.defaultImg}
                  style="width: 100px;height: 40px"
                  preview-teleported={true}
                  preview-srcList={[row.picurl3 ? row.picurl3 : this.defaultImg]}
                ></el-image>
              );
            },
            form: {
              //表单属性
              span: 12,
              width: 200,
              height: 80,
              hidden: false,
            },
          },
          {
            label: "展示图片4",
            prop: "picurl4",
            type: "image-avatar",
            minWidth: "60",
            sortable: false,
            hidden: true,
            render: (row) => {
              return (
                <el-image
                  src={row.picurl4 ? row.picurl4 : this.defaultImg}
                  style="width: 100px;height: 40px"
                  preview-teleported={true}
                  preview-srcList={[row.picurl4 ? row.picurl4 : this.defaultImg]}
                ></el-image>
              );
            },
            form: {
              //表单属性
              span: 12,
              width: 200,
              height: 80,
              hidden: false,
            },
          },
          {
            label: "LOGO",
            prop: "logo",
            type: "image-avatar",
            minWidth: "60",
            sortable: false,
            hidden: true,
            render: (row) => {
              return (
                <el-image
                  src={row.picurl4 ? row.picurl4 : this.defaultImg}
                  style="width: 100px;height: 40px"
                  preview-teleported={true}
                  preview-srcList={[row.picurl4 ? row.picurl4 : this.defaultImg]}
                ></el-image>
              );
            },
            form: {
              //表单属性
              span: 12,
              width: 200,
              height: 80,
              hidden: false,
            },
          },
          {
            label: "中文简介",
            prop: "introduction_ch",
            type: "textarea",
            minWidth: "110",
            sortable: false,
            hidden: true,
            form: {
              //表单属性
              span: 24,
              placeholder: "",
            },
          },
          {
            label: "中文联系方式",
            prop: "contact_ch",
            type: "textarea",
            minWidth: "110",
            sortable: false,
            hidden: true,
            form: {
              //表单属性
              span: 24,
              placeholder: "",
            },
          },
          {
            label: "英文简介",
            prop: "introduction_en",
            type: "textarea",
            minWidth: "110",
            sortable: false,
            hidden: true,
            form: {
              //表单属性
              span: 24,
              placeholder: "",
            },
          },
          {
            label: "英文联系方式",
            prop: "contact_en",
            type: "textarea",
            minWidth: "110",
            sortable: false,
            hidden: true,
            form: {
              //表单属性
              span: 24,
              placeholder: "",
            },
          },
          {
            label: "设备定制",
            prop: "eq_type",
            type: "checkbox",
            minWidth: "110",
            sortable: false,
            hidden: true,
            form: {
              //表单属性
              span: 24,
              placeholder: "",
              options: eq_type_list,
              valueChange(e) { // 值变化回调事件
                  console.log(e, '---变化的值');
              },
            },
          },
          /* {
            label: "连接密码状态",
            prop: "pwd_flag",
            type: "radio",
            minWidth: "100",
            sortable: false,
            hidden: false,
            render: (row) => {
              let elTag = resolveComponent("el-tag"); // 解析全局组件
              if (row.pwd_flag === 2) {
                return h(
                  elTag,
                  {
                    type: "warning",
                  },
                  () => "禁用"
                ); // 返回 "禁用"
              } else {
                return h(
                  elTag,
                  {
                    type: "success",
                  },
                  () => "正常"
                ); // 返回 "正常"
              }
            },
            form: {
              // 表单属性
              span: 24,
              options: [
                { label: "正常", value: 1 },
                { label: "禁用", value: 2 },
              ],
              defaultValue: 1, // 新增时的默认值，改为 1 表示启用
              // valueChange(e) { // 值变化回调事件
              //     console.log(e, '---变化的值');
              // },
            },
          }, */
        ],
      },
    };
  },
  async mounted() {

    await authorization_code_eq_typeList({ 'limit': 30 }).then((res) => {
      console.log(res);
      const uniqueNames = new Set(); // 使用 Set 来确保唯一性
      if (eq_type_list.length != res.data.data.length) {
        res.data.data.forEach((item) => {
          if (!uniqueNames.has(item.name)) {
            eq_type_list.push({
              label: item.name,
              value: item.name,
              device: item.device,
            });
            uniqueNames.add(item.name); // 将已添加的名称加入 Set 中
          }
        });
      }


      console.log('eq_type_list:', eq_type_list);
    });
  },
  methods: {

    downloadIamge(imgsrc, name) {//下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    //自定义操作列按钮方法
    handleClick(row, flag) {
      let vm = this;
      if (flag == "disable") {
        UsersUsersdisableEdit({ id: row.id }).then((res) => {
          if (res.code == 2000) {
            vm.$message.success(res.msg);
            vm.$refs.lycrud.handleRefresh(); //刷新表格数据
          } else {
            vm.$message.warning(res.msg);
          }
        });
      }
    },
    updateURL(url, newCode) {
      // 检查URL是否符合预期格式，并提取文件名
      // 提取文件名
      const fileName = url.substring(url.lastIndexOf("/") + 1);
      // 构造新的URL
      const newBaseURL = `https://rmtest.chinasimba.com/media/Authorization_code/${newCode}/`;
      return newBaseURL + fileName;
      console.log(newBaseURL + fileName)
    },
  },
};
</script>


